"use client";
import { useEffect, useState } from "react";
import { Heading } from "./heading";
import { Subheading } from "./subheading";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslations } from "next-intl";

const integrationSets = [
  ["Twilio", "HubSpot", "Slack", "Google Calendar"],
  ["Stripe", "Zapier", "Outlook", "Gmail"],
];

export const Integrations = () => {
  const t = useTranslations("integrations");
  const [sets, setSets] = useState(integrationSets);
  const [active, setActive] = useState(integrationSets[0]);
  const [isAnimating, setIsAnimating] = useState(false);

  const flip = () => {
    setSets((current) => {
      const next = [...current.slice(1), current[0]];
      setActive(next[0]);
      setIsAnimating(true);
      return next;
    });
  };

  useEffect(() => {
    if (!isAnimating) {
      const timer = setTimeout(flip, 3000);
      return () => clearTimeout(timer);
    }
  }, [isAnimating]);

  return (
    <div className="relative z-20 py-10 md:py-40">
      <Heading as="h2">{t("heading")}</Heading>
      <Subheading className="text-center">{t("subheading")}</Subheading>

      <div className="flex gap-6 flex-wrap justify-center md:gap-16 relative h-full w-full mt-20">
        <AnimatePresence
          mode="popLayout"
          onExitComplete={() => setIsAnimating(false)}
        >
          {active.map((name, idx) => (
            <motion.div
              key={name}
              initial={{ y: 40, opacity: 0, filter: "blur(10px)" }}
              animate={{ y: 0, opacity: 1, filter: "blur(0px)" }}
              exit={{ y: -40, opacity: 0, filter: "blur(10px)" }}
              transition={{
                duration: 0.8,
                delay: 0.1 * idx,
                ease: [0.4, 0, 0.2, 1],
              }}
              className="relative"
            >
              <div className="flex items-center justify-center px-6 py-3 rounded-xl border border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 shadow-sm min-w-[120px]">
                <span className="text-sm font-semibold text-neutral-700 dark:text-neutral-200 tracking-tight">
                  {name}
                </span>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

// Backward-compat alias used by old (marketing) pages
export { Integrations as Companies };
